<template>
  <div>
    <HeadBanner page-type="home" />
    <div class="c-homePage">
      <HomeHeroArea
        class="c-contentHeader"
        :hero-areas-list="heroArea"
      />
      <div class="c-columns">
        <HomeMainContent
          :home-content="homeContent"
          :my-service-histories="myServiceHistories"
          :my-favorite-services="myFavoriteServices"
          class="c-columns_main"
        />
        <HomeAsideContent class="c-columns_side" />
      </div>
      <div class="c-footer">
        <HomeFooterContent :news="homeContent.newsList" />
      </div>
    </div>
    <ClientOnly>
      <GlobalPopup v-if="isLoggedIn" />
    </ClientOnly>
    <BLoading
      :active="$fetchState.pending"
      is-full-page
    />
    <TheVueport breakpoint-type="vueportHome" />
  </div>
</template>
<script>
import Promise from 'bluebird'

import { mapGetters, mapState } from 'vuex'

import HeadBanner from '~/components/organisms/HeadBanner'
import HomeAsideContent from '~/components/organisms/HomeAsideContent'
import HomeFooterContent from '~/components/organisms/HomeFooterContent'
import HomeHeroArea from '~/components/organisms/HomeHeroArea'
import HomeMainContent from '~/components/organisms/HomeMainContent'
import TheVueport from '~/components/organisms/TheVueport'

// nuxt.config.jsに書いてもグローバルに効かなかったのでローカルで設定する
Promise.config({ cancellation: true })

const TITLE = 'ココナラ - プロが集まる日本最大級のスキルマーケット'
const DESCRIPTION =
  'ココナラは、いろんなジャンルの「仕事」や「相談」をネットショッピングのように早く・簡単・おトクに依頼できます！ロゴや名刺などのデザイン、動画・サイト制作、お悩み相談など、ビジネスやプライベートで自分ではできないことをプロや専門家に依頼しませんか？No.1スキルマーケットのココナラ！'
const KEYWORDS = 'スキルマーケット,スキルシェア,マーケットプレイス,ココナラ,coconala,ここなら'
const RECENTLY_VIEWED_COOKIE_KEY_V2 = 'service_history'

export default {
  name: 'PrivateIndex',
  components: {
    HeadBanner,
    HomeAsideContent,
    HomeFooterContent,
    HomeHeroArea,
    HomeMainContent,
    TheVueport,
    GlobalPopup: () =>
      import('~/components/organisms/GlobalPopup' /* webpackChunkName: "GlobalPopup" */)
  },
  head() {
    return this.head
  },
  data() {
    return {
      homeContent: {
        categoryRanking: {
          detailsList: [],
          rankingTermEnd: null,
          rankingTermStart: null
        },
        heroAreasList: [],
        heroAreasNoLoggedInList: [],
        newsList: [],
        recommendBlogsList: [],
        recommendRequestsList: [],
        recommendServicesList: [],
        recommendUsersList: [],
        useScenesList: [],
        legalQasList: []
      },
      myServiceHistories: [],
      myFavoriteServices: [],
      isLoading: false,
      linkSpecs: {
        /** 人気のカテゴリ見出し部 */
        popularCategories: {
          link: '/services',
          text: 'すべてのカテゴリをみる',
          isNuxtLink: true
        }
      }
    }
  },
  async fetch() {
    const { fullPath } = this.$route
    // TODO: api実装後につなぎこみ
    // ブログ検索でSSRとCSRの二重リクエストが発生したが再現しなかったので制御は入れず様子見する
    const promises = [
      new Promise((resolve, reject) => {
        this.$store
          .dispatch('pages/home/home/homeContentRequests', fullPath)
          .then(resolve)
          .catch(reject)
      })
    ]
    // 閲覧履歴とお気に入りは通信でエラーが発生しても握りつぶしている（表示しない)
    if (this.$store.getters['auth/isLoggedIn']) {
      promises.push(this.$store.dispatch('pages/home/home/myFavoriteServicesRequests'))
      const cookie = this.$cookies.get(RECENTLY_VIEWED_COOKIE_KEY_V2) || ''
      if (cookie) {
        promises.push(this.$store.dispatch('pages/home/home/myServiceHistoriesRequests', cookie))
      }
    }
    try {
      const [res1, res2, res3] = await Promise.all(promises)
      this.homeContent = res1
      if (res2) {
        this.myFavoriteServices = res2.servicesList
      }
      if (res3) {
        this.myServiceHistories = res3.servicesList
      }
    } catch (err) {
      const statusCode = this.$util.grpcCodeToHttpStatusCode(Number(err.grpcCode))
      return this.$nuxt.context.error({
        statusCode,
        message: '',
        grpcCode: err.grpcCode
      })
    }
  },
  mounted() {
    this.setDataLayer()
  },
  computed: {
    ...mapState('pages/users', ['user']),
    ...mapState('constants', ['serviceClass', 'VIRTUAL_CATEGORY']),
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapGetters('auth', ['isFromCoconalaApp', 'isLoggedIn']),
    head() {
      return {
        __dangerouslyDisableSanitizers: ['script'],
        link: [{ rel: 'canonical', href: 'https://coconala.com/' }],
        title: TITLE,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: DESCRIPTION
          },
          {
            hid: 'Keywords',
            name: 'Keywords',
            content: KEYWORDS
          },
          ...this.metaOgp
        ]
      }
    },
    scrollToOffset() {
      if (this.isSP) {
        return -19
      } else if (this.isTB) {
        return 0
      } else {
        return -90
      }
    },
    metaOgp() {
      return [
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://coconala.com/'
        },
        {
          hid: 'og:type',
          property: 'og:type',
          content: 'website'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: TITLE
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: 'ja_JP'
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'ココナラ'
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: DESCRIPTION
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'http://coconala.com/images/facebook.png'
        }
      ]
    },
    heroArea() {
      if (this.isLoggedIn) {
        return this.homeContent.heroAreasList
      }
      return this.homeContent.heroAreasNoLoggedInList
    }
  },
  methods: {
    setDataLayer() {
      if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = []
      }
      window.dataLayer.push({
        pagetype: 'home'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-contentHeader {
  margin: 20px auto 32px;
  width: 1280px;
}

.c-homePage {
  position: relative;
  margin: 0 auto;
  max-width: 1280px;
}

.c-columns {
  display: flex;
  margin: 12px 20px 0;

  justify-content: space-between;
}

@media (min-width: breakpoint(Home, M) + 1) {
  .c-homePage {
    overflow-x: auto;

    -ms-overflow-style: none; /* IE, Edge 対応 */
    scrollbar-width: none; /* Firefox 対応 */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari 対応 */
    }
  }

  .c-columns {
    flex-direction: row-reverse;
    width: 1240px;

    &_main {
      flex: 0 0 964px;
      width: 964px;
    }

    &_side {
      flex: 0 0 256px;
      margin-right: 20px;
      width: 256px;
    }
  }

  .c-footer {
    margin: 0 20px;
    width: 1240px;
  }
}

@media (max-width: breakpoint(Home, M)) {
  .c-contentHeader {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  .c-homePage {
    max-width: 100%;
    font-size: 14px;
  }

  .c-columns {
    flex-direction: column;
    margin: 0;
    &_side {
      margin-top: 45px;
    }
  }

  .c-footer {
    padding-bottom: 60px;
  }
}
</style>
